import { render, staticRenderFns } from "./add-activity-goods.vue?vue&type=template&id=4be0fea6&scoped=true&"
import script from "./add-activity-goods.vue?vue&type=script&lang=js&"
export * from "./add-activity-goods.vue?vue&type=script&lang=js&"
import style0 from "./add-activity-goods.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./add-activity-goods.vue?vue&type=style&index=1&id=4be0fea6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0fea6",
  null
  
)

export default component.exports